import { createContext, useContext } from 'react'

type LayoutContextValue = {
  searchValue: string
  setSearchValue: (value: string) => void
  searchOpen: boolean
  setSearchOpen: (open: boolean) => void
  openInfo: () => void
}

export const LayoutContext = createContext<LayoutContextValue>({
  searchValue: '',
  setSearchValue: () => undefined,
  searchOpen: false,
  setSearchOpen: () => undefined,
  openInfo: () => undefined,
})

export const useLayout = () => useContext(LayoutContext)
